module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm7"
    }
  }, [_c('p', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CODE NAME: GRAND GUIGNOL")]), _vm._v(" is based on a fantastic, little-known scheme of the Nazis during World War II just before D-Day — a scheme that has been “forgotten” in the dramatic events that followed the invasion, but a scheme that, had it been successful, might drastically have altered those events.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03116db0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Code_Name_Grand_Guignol.vue
// module id = 78
// module chunks = 0